import { name } from '../symbols'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaPageConfig } from '../types'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'

export const GetStyleIdHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	(tpaPageConfig: TpaPageConfig): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				getStyleId(compId, msgData, { originCompId }): string {
					return tpaPageConfig.widgets[originCompId].styleId
				},
			}
		},
	})
)
